"use strict";
/**
 * Moderation API Types
 *
 * Types for pattern and review moderation system.
 *
 * Derivation chain:
 * - ModerationSnapshotResponse: standalone — assembled from S3 content + moderation record fields,
 *   not a direct sanitized record projection. Fields are hand-mapped in getModerationPreview.
 * - CraftRoomModerationItem: derived from CraftRoomPolicyViolationRecord via Pick (no sanitization)
 * - ReviewFlagItem: derived from UnifiedFlagRecord via SanitizedRecord + extension for legacy fields
 * - UnifiedModerationItem: standalone with index signature — unified queue returns polymorphic items
 *   from multiple record types (ModerationSnapshotRecord, ContentModerationRecord, UnifiedFlagRecord,
 *   CraftRoomPolicyViolationRecord). A discriminated union is not feasible because the handler returns
 *   raw DynamoDB items without normalization, and each record type has different field shapes.
 *   The [key: string]: unknown pattern is intentional to accommodate this polymorphism.
 *
 * Consumed by: lambda-secure, free-pattern-warehouse-website
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScanResult = void 0;
const scan_result_1 = require("../enums/scan-result");
Object.defineProperty(exports, "ScanResult", { enumerable: true, get: function () { return scan_result_1.PublishScanResult; } });
